




























































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import SignInForm from '@/components/signIn/SignInForm.vue'
import SignUpForm from '@/components/signUp/SignUpForm.vue'
import LangSwitcher from '@/components/common/layout/LangSwitcher.vue'
import SurveyService from '@/services/SurveyService'
import { SurveyInfo, SurveyProductTypes, SurveyUserInfo } from '@/interfaces/SurveyInterfaces'
import { MainLogosTypes } from '@/interfaces/GeneralInterfaces'
import SurveyLocalStorageHelper from '@/utils/SurveyLocalStorageHelper'
import SurveyHelper from '@/utils/SurveyHelper'
import { EventBus } from '@/main'
import { SurveyData } from '@/interfaces/LocalStorageInterfaces'
import TsService from '@/services/TsService'
import { TsUserDto, User } from '@/interfaces'
import { urls } from '@/config'

@Component({
  name: 'WelcomePage',
  components: {
    SignInForm,
    SignUpForm,
    LangSwitcher
  }
})
export default class WelcomePage extends Vue {
  @Getter('user/isAuthenticated')
  isAuthenticated!: boolean

  @Getter('user/currentUser')
  user!: User

  @Getter('ts/getUsers')
  tsUserInfo!: TsUserDto

  @Prop({})
  surveyProduct!: string
  @Prop({})
  accessCode!: string

  surveyInfo: SurveyInfo | null = null
  productSurveyId!: number
  isUncompletedSurvey: boolean = false
  surveyUserInfo!: SurveyUserInfo
  signInLinkId = 'sign-in-link-in-welcome'
  surveyData: SurveyData | null = null
  error: string = ''
  tabIndex: number = 0

  async created () {
    try {
      const response = await SurveyService.getProductSurveyInfo(
        this.surveyProduct,
        this.accessCode
      )

      this.surveyInfo = response.survey
      this.productSurveyId = response.surveyProductId
      this.isUncompletedSurvey = SurveyLocalStorageHelper.hasBegunSurvey(this.surveyProduct, this.productSurveyId)

      this.$store.commit('mainLogo/setLogos', response.survey.logos)
      if (response.survey.logos && response.survey.logos.length > 0) {
        this.$store.commit('guestLogo/setLogos', response.survey.logos)
      }

      this.$store.commit('mainLogo/setType', MainLogosTypes.SURVEY_LOGOS)

      if (!this.isAuthenticated && this.surveyInfo) {
        EventBus.$emit('languageChanged', this.surveyInfo.defaultLanguage)
      }

      SurveyHelper.checkSurveyInfo(response.survey)

      if (this.surveyProduct === SurveyHelper.TS) {
        await this.checkTsSurvey()
        return
      }

      if (this.surveyUserInfo && SurveyLocalStorageHelper.hasSurveyUser(this.surveyProduct, this.surveyUserInfo.surveyUserId)) {
        this.surveyData = SurveyLocalStorageHelper.getSurveyUser(this.surveyProduct, this.surveyUserInfo.surveyUserId)
      }

      if (this.isAuthenticated && !this.isUncompletedSurvey) {
        const completedSurveyUserInfo = await SurveyService.getCompletedSurveyUser(
            this.surveyProduct,
            this.productSurveyId,
            this.accessCode
          )
          if (completedSurveyUserInfo && !(completedSurveyUserInfo as any).canRetakeSurvey) {        
            this.$router.push({
              name: 'survey.complete',
              params: { title: this.surveyInfo.title, reason: 'survey_has_no_retake_access' }
            })
            return         
        }
        
      }

      if (this.isAuthenticated && !this.isUncompletedSurvey && this.surveyInfo && !this.surveyInfo.isUnlimitedAccess) {
        const completedSurveyUserInfo = await SurveyService.getCompletedSurveyUser(
          this.surveyProduct,
          this.productSurveyId,
          this.accessCode
        )
        if (completedSurveyUserInfo && completedSurveyUserInfo.isCompleted) {
          this.$router.push({
            name: 'survey.complete',
            params: { title: this.surveyInfo.title, reason: 'survey_has_already_passed' }
          })
          return
        }
      }

      EventBus.$on('authorizedComplete', async () => {
        await this.beginSurvey()
      })

      this.$store.commit('survey/setTakenSurveyData', {
        productSurveyId: this.productSurveyId,
        productSurveyType: this.surveyProduct,
        surveyInfo: this.surveyInfo
      })
    } catch (error) {
      // TODO::add handler to process for errors(go to 404)
      if (error instanceof TypeError) {
        this.error = error.message
      } else {
        this.$router.push({ name: 'notFound' })
      }
    }
  }

  async mounted () {
    let signInLink = document.querySelector(`#${this.signInLinkId}`)
    if (signInLink) {
      signInLink.addEventListener('click', (): void => {
        this.changeForm('signIn')
      })
    }
    EventBus.$on('authorizedComplete', async () => {
      await this.checkTsSurvey()
    })
  }

  changeForm (formName: string) {
    if (formName === 'signIn') {
      this.tabIndex = 1
    } else {
      this.tabIndex = 0
    }
  }

  async beginSurvey () {
    if (!this.surveyInfo) {
      return
    }

    if (this.surveyProduct === SurveyHelper.TS) {
      await this.$router.push({
        name: 'survey.ts.dashboard',
        params: {
          tsSurveyId: this.productSurveyId.toString()
        }
      })
      return
    }

    try {
      SurveyHelper.checkSurveyInfo(this.surveyInfo)
    } catch (error) {
      this.error = error.message
      return
    }

    this.surveyUserInfo = await SurveyService.getSurveyUser(
      this.surveyProduct,
      this.productSurveyId,
      this.accessCode
    ) ||
      await SurveyService.createSurveyUser(
        this.surveyProduct,
        this.productSurveyId,
        this.accessCode
      )
    if (!SurveyHelper.isAuthorized(this.surveyUserInfo)) {
      window.location.href =
        urls.app +
        '/payment?' + SurveyHelper.paymentSurveyUserIdKey(this.surveyProduct) +
        '=' + String(this.surveyUserInfo.surveyUserId)
      return
    }

    if (!SurveyHelper.isSurveyUserAvailable(this.surveyUserInfo)) {
      const title = this.surveyData ? this.surveyData.surveyProductTitle : ''
      SurveyHelper.completeSurvey(this.surveyProduct, this.productSurveyId, this.surveyUserInfo.surveyUserId)
      this.$router.push({ name: 'survey.complete', params: { title } })
      // todo::[m] Add logic for handling completed survey
      // todo::[m] I leave these comments there, because logic of the completed survey is not fully described at moment
    }

    this.$store.commit('survey/setTakenSurveyUserId', {
      productSurveyType: this.surveyProduct,
      surveyUserId: this.surveyUserInfo.surveyUserId
    })

    let storageSurveyUserInfo = SurveyLocalStorageHelper.getSurveyUser(
      this.surveyProduct,
      this.surveyUserInfo.surveyUserId
    )
    if (!storageSurveyUserInfo) {
      storageSurveyUserInfo = {
        surveyProductType: this.surveyProduct,
        surveyAccessCode: this.accessCode,
        surveyProductId: this.productSurveyId,
        surveyProductTitle: this.surveyInfo!.title,
        surveyUserId: this.surveyUserInfo.surveyUserId,
        dpSurveyId: null,
        dpChildSurveys: []
      }
    }

    SurveyLocalStorageHelper.beginSurvey(storageSurveyUserInfo)

    if (this.surveyProduct === SurveyHelper.DP) {
      await this.beginDpSurvey()
      return
    }

    const routerName = this.surveyProduct === SurveyProductTypes.IPULSE ? 'survey.ipulse.page.part' : 'survey.page.part'

    this.$router.push({
      name: routerName,
      params: {
        surveyProduct: this.surveyProduct,
        surveyUserId: this.surveyUserInfo.surveyUserId.toString(),
        sectionNumber: '1'
      }
    })
  }

  async beginDpSurvey (): Promise<void> {
    const progress = await SurveyService.getDpSurveyProgress(this.surveyUserInfo.surveyUserId)

    if (progress.isCompleted || !progress.nextSurveyPart) {
      const title = this.surveyData ? this.surveyData.surveyProductTitle : ''
      SurveyHelper.completeSurvey(SurveyHelper.DP, this.productSurveyId, this.surveyUserInfo.surveyUserId)
      this.$router.push({ name: 'survey.complete', params: { title } })
      // todo::[m] Add logic for handling completed survey
      // todo::[m] I leave these comments there, because logic of the completed survey is not fully described at moment
      return
    }

    const nextSurveyProductInfo = await SurveyService.getSurveyInfoById(
      progress.nextSurveyPart.product,
      progress.nextSurveyPart.id
    )

    this.$store.commit('survey/setTakenSurveyData', {
      productSurveyId: progress.nextSurveyPart.id,
      productSurveyType: progress.nextSurveyPart.product,
      surveyInfo: nextSurveyProductInfo
    })

    this.$store.commit('mainLogo/setLogos', nextSurveyProductInfo.logos)
    this.$store.commit('mainLogo/setType', MainLogosTypes.SURVEY_LOGOS)

    this.$store.commit('survey/setTakenSurveyUserId', {
      productSurveyType: progress.nextSurveyPart.product,
      surveyUserId: progress.nextSurveyPart.surveyUserId
    })

    SurveyLocalStorageHelper.addDpChildSurveyUser(
      this.surveyUserInfo.surveyUserId,
      progress.nextSurveyPart.product,
      progress.nextSurveyPart.surveyUserId
    )

    this.$router.push({
      name: 'survey.welcome.dp.survey_product',
      params: {
        surveyProduct: progress.nextSurveyPart.product,
        surveyUserId: progress.nextSurveyPart.surveyUserId.toString()
      }
    })
  }

  async checkTsSurvey (): Promise<void> {
    if (this.surveyProduct !== SurveyHelper.TS) {
      return
    }

    await this.$store.commit('survey/setTakenSurveyData', {
      productSurveyId: this.productSurveyId,
      productSurveyType: this.surveyProduct,
      surveyInfo: this.surveyInfo
    })

    if (!this.isAuthenticated) {
      return
    }

    const tsUser = await TsService.getUserInfo(this.productSurveyId, this.user.id)
    this.$store.commit('ts/setUsers', tsUser)
    this.$store.commit('mainLogo/setType', MainLogosTypes.SURVEY_LOGOS)
  }
}
